import Vue from 'vue'
import VueRouter from 'vue-router'
import { X_TOKEN } from '@/data/Constant'
import { Toast } from 'vant'

Vue.use(VueRouter)

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/)
// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const childrenRoutes = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const value = modulesFiles(modulePath)
  modules.push(...value.default)
  return modules
}, [])

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/orgs',
      name: 'organizations',
      component: () => import(/* webpackChunkName: "organizations" */ '@/views/Organizations')
    },
    {
      path: '/org/:organizationId',
      name: 'index',
      redirect: '/org/:organizationId/studio/teachers',
      component: () => import(/* webpackChunkName: "index" */ '@/views'),
      children: childrenRoutes
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  }
})
const filterName = ['login', 'organizations']

let _toast
// 必须要登录才能使用
router.beforeEach((to, from, next) => {
  _toast = Toast.loading({
    forbidClick: true,
    loadingType: 'spinner'
  })
  const { organizationId } = to.params
  if (Vue.ls.get(X_TOKEN) || filterName.indexOf(to.name) !== -1) {
    next()
  } else if (to.fullPath === '/') {
    next({ name: 'organizations' })
  } else {
    next({ name: 'login', params: { organizationId }, query: { 'redirect_to': to.fullPath }})
  }
})

router.afterEach(() => {
  _toast.clear()
})

export default router
